export type QuestionToQuestionMapper = {
  [FROM: number]: {
    [TO: number]: (input: any) => any;
  };
};

export const getMapper = () => {
  let questionMap: QuestionToQuestionMapper = {} as QuestionToQuestionMapper;

  const map = () => ({
    from: (fromType: number) => {
      if (!questionMap[fromType]) {
        questionMap[fromType] = {};
      }
      const to = (toType: number) => {
        return {
          mapper: <TFrom, TTo>(callback: (input: TFrom) => TTo) => {
            questionMap[fromType][toType] = callback;
            return { map, create, to };
          },
        };
      };
      return {
        to,
      };
    },
  });

  const create = (): Readonly<QuestionToQuestionMapper> => {
    return questionMap;
  };

  return { map, create };
};
